// hooks/useUserPlans.ts
import { useQuery } from '@tanstack/react-query';

import { mapConfigPlans } from '@/components/utils/utils';
import { PlanItem } from '@/interfaces/api/configApp/IPlanItem';
import { haggleApiService } from '@/services/haggle.service';

export const useConfigPlans = () => {
	const {
		data: rawData,
		isLoading,
		isError,
		error,
		refetch,
	} = useQuery({
		queryKey: ['configPlans'],
		queryFn: () => haggleApiService.getPlans(),
		refetchOnWindowFocus: false,
	});

	const plans: PlanItem[] = rawData?.data ? mapConfigPlans(rawData.data) : [];

	return {
		plans,
		isLoading,
		isError,
		error,
		refetch,
	};
};
